import React from "react";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import {
  getRechartData,
  getUniqueRecordFromProperty
} from "../../../utils/graph_service";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { orderBy, PaperComponent } from "../../../utils/helper";
import RenderGroupedVerticalBarChart from "../../common/Chart/GroupedVerticalBarChart";
import RenderGroupedHorizontalBarChart from "../../common/Chart/GroupedHorizontalBarChart";
import {
  AppBar,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import _ from "lodash";
import PopupTable from "../../common/Table/PopupTable";
import { IoMdCloseCircleOutline } from "react-icons/io";

const configDataVerticalList = {
  trend: {
    key: "CategoryName"
  },
  distinctOn: "IncidentId",
  columns: [
    {
      key: "RegionName",
      value: "Northern Region",
      color: "#ff7200",
      sortOrder: 1
    },
    {
      key: "RegionName",
      value: "Southern Region",
      color: "#2D76E5",
      sortOrder: 1
    }
  ]
};

const configDataHorizontalList = {
  trend: {
    key: "SubCategoryName"
  },
  columns: [
    {
      key: "RegionName",
      value: "Northern Region",
      color: "#ff7200",
      sortOrder: 1
    },
    {
      key: "RegionName",
      value: "Southern Region",
      color: "#2D76E5",
      sortOrder: 1
    }
  ]
};

const columns = [
  {
    name: "Observation #",
    key: "IncidentCode",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Data Center",
    key: "DataCenterName",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Observation Date",
    key: "ObservationDate",
    isSort: true,
    dataFormat: "Date"
  },
  {
    name: "Category",
    key: "CategoryName",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Sub Category",
    key: "SubCategoryName",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Source System",
    key: "SourceSystem",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Status",
    key: "IncidentStatus",
    dataFormat: "Text"
  }
];

const summaryColumn = [
  {
    name: "Data Center Name",
    key: "data",
    isSort: true,
    dataFormat: "Text"
  },
  {
    name: "Count",
    key: "count",
    isSort: true,
    dataFormat: "Text",
    isLink: true,
    countFilterKey: "data"
  }
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component={"div"}
      role={"tabpanel"}
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}
class HealthAndSeftyGrphBarChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      healthAndSafetyDataVertical: [],
      healthAndSafetyDataHorizontal: [],
      isOpen: false,
      header: "",
      originalHealthAndSafety: [],
      filteredHealthAndSafety: [],
      pageNo: 0,
      rowsPerPagination: 5,
      rowsPerPageOptions: [5, 10, 25, 50],
      order: "",
      orderBy: "desc",
      configDataVertical: configDataVerticalList,
      configDataHorizontal: configDataHorizontalList,
      selectedTabvalue: 0,
      filterKey: "",
      specificBar: undefined,
      groupedBar: [],
      filterBy: ""
    };
  }

  componentDidMount() {
    this.GetHealthAndSafetyData(
      this.props.propertyId,
      this.props.startDate,
      this.props.endDate,
      this.props.dataSource
    );
  }

  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.startDate != this.props.startDate ||
      newProps.endDate != this.props.endDate ||
      newProps.typeOfDate != this.props.typeOfDate ||
      newProps.toUpdateGraph != this.props.toUpdateGraph ||
      newProps.dataSource != this.props.dataSource
    ) {
      this.GetHealthAndSafetyData(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate,
        newProps.dataSource
      );
    }
  }

  /** Get Health and safety data according to property id, start date and end date and prepare data as per both vertical and horizontal bar graph */
  GetHealthAndSafetyData = async (propertyId, startDate, endDate) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };
    await apiRequest({
      url: API_URL.reports.GetHSEIncidentKPISummary,
      params
    }).then(({ data: incidentReports }) => {
      let configDataHorizontal = [];
      let configDataVertical = [];
      let responseDataVertical = [];
      let responseDataHorizontal = [];
      const { dataSource } = this.props;
      const selectedDataCenter = (dataSource || []).filter(
        x =>
          (propertyId || "")
            .split(",")
            .indexOf((x.propertyID || "").toString()) !== -1
      );
      if (selectedDataCenter && selectedDataCenter.length > 0) {
        configDataHorizontal = _.cloneDeep(configDataHorizontalList);
        configDataVertical = _.cloneDeep(configDataVerticalList);

        const uniqueObjArray = [
          ...new Map(
            selectedDataCenter.map(item => [item["regionName"], item])
          ).values()
        ];

        configDataHorizontal.columns = configDataHorizontal.columns.filter(
          y => {
            return (
              uniqueObjArray
                .map(x => x.regionName)
                .find(x => (x || "") === (y.value || "")) !== undefined
            );
          }
        );
        configDataVertical.columns = configDataVertical.columns.filter(y => {
          return (
            uniqueObjArray
              .map(x => x.regionName)
              .find(x => (x || "") === (y.value || "")) !== undefined
          );
        });
        responseDataVertical = getRechartData(
          incidentReports,
          configDataVertical,
          incidentReports
        );

        responseDataHorizontal = getRechartData(
          incidentReports,
          configDataHorizontal,
          incidentReports
        );
      }
      // Task 21841: KPI / HSE, sort display of the bars i.e. Display Category/sub category bar with high to low count from left to right.  Count equals the sum of Southern and Northern region count.
      responseDataVertical.data = _.orderBy(
        responseDataVertical.data || [],
        ["totalCount", "CategoryName"],
        ["desc", "asc"]
      );
      responseDataHorizontal.data = _.orderBy(
        responseDataHorizontal.data || [],
        ["totalCount", "SubCategoryName"],
        ["desc", "asc"]
      );

      this.setState({
        healthAndSafetyDataVertical: responseDataVertical.data || [],
        healthAndSafetyDataHorizontal: responseDataHorizontal.data || [],
        originalHealthAndSafety: incidentReports || [],
        configDataVertical: configDataVertical,
        configDataHorizontal
      });
    });
  };

  /** prepare object to display data on popup according to both tab, sorting the data according to applied column and filter data according to selected property */
  GetSummary = (type, data, key) => {
    const { originalHealthAndSafety, selectedTabvalue, filterBy } = this.state;
    const header = type.value + ": " + data[key];
    let filteredData = [];
    filteredData = originalHealthAndSafety.filter(
      x => x.RegionName === type.value && x[key] === data[key]
    );
    // if condition is true when Summary tab is selected else detail tab is selected in popup
    if (selectedTabvalue === 0) {
      let groupedData = _(filteredData).groupBy("DataCenterName");
      // if condition is true then selected popup is in category bar graph and group by date unique observation id and default key data center name for summary tab.
      if (key === "CategoryName") {
        groupedData = groupedData
          .map(function(items, DataCenterName) {
            return {
              data: DataCenterName,
              count: (getUniqueRecordFromProperty(items, "IncidentId") || [])
                .length
            };
          })
          .value();
      } else {
        // selected popup is in sub-category bar graph and group by default key i.e. data center name for summary tab.
        groupedData = groupedData
          .map(function(items, DataCenterName) {
            return { data: DataCenterName, count: items?.length };
          })
          .value();
      }
      filteredData = _.orderBy(groupedData, ["data"], ["desc"]);
    } else {
      // if condition is true then selected popup is in category bar graph and group by date unique observation id and default key data center name for detail tab.
      if (key === "CategoryName") {
        filteredData = _.orderBy(
          getUniqueRecordFromProperty(filteredData || [], "IncidentId") || [],
          ["DataCenterName", "ObservationDate", "IncidentCode"],
          ["desc", "desc", "desc"]
        );
      } else {
        // selected popup is in sub-category bar graph and group by default key i.e. data center name for details tab.
        filteredData = _.orderBy(
          filteredData || [],
          ["DataCenterName", "ObservationDate", "IncidentCode"],
          ["desc", "desc", "desc"]
        );
      }
      if (filterBy && filterBy.length > 0) {
        filteredData = filteredData.filter(x => x.DataCenterName === filterBy);
      }
    }
    this.setState({
      isOpen: true,
      header,
      filteredHealthAndSafety: filteredData || [],
      filterKey: key,
      specificBar: type,
      groupedBar: data
    });
  };

  /** update the page number and rows per page according page selection */
  updateRowCount = (pageNo, rowsPerPagination) => {
    this.setState({ pageNo, rowsPerPagination });
  };

  /** apply the sorting according to applied property */
  sortBy = property => {
    let { filteredHealthAndSafety } = this.state;
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    filteredHealthAndSafety = orderBy(
      filteredHealthAndSafety,
      property,
      isAsc ? "desc" : "asc"
    );
    this.setState({
      order: isAsc ? "desc" : "asc",
      orderBy: property,
      filteredHealthAndSafety
    });
  };

  /** return tab id of popup */
  tabProps = index => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabPanel-${index}`
    };
  };

  /** set the tab according to tab selection and prepare the tab data according to tab selection */
  handleTabChange = (event, newValue, isFilter = false) => {
    if (newValue !== this.state.selectedTabvalue) {
      const { filterKey, specificBar, groupedBar,filterBy } = this.state;
      this.setState(
        {
          selectedTabvalue: newValue,
          filteredHealthAndSafety: [],
          isOpen: false,
          pageNo: 0,
          rowsPerPagination: 5,
          order: "",
          orderBy: "desc",
          filterBy: isFilter ? filterBy : ""
        },
        () => {
          this.GetSummary(specificBar, groupedBar, filterKey);
        }
      );
    }
  };

  /** redirect the details tab according to count selection and filter data according to selected property */
  onCountClick = (event, dataCenterName) => {
    this.setState(
      {
        filterBy: dataCenterName
      },
      () => {
        this.handleTabChange(event, 1, true);
      }
    );
  };

  /** reset or default value the flag when click on cross sign of popup */
  closePopup = () => {
    this.setState({
      isOpen: false,
      pageNo: 0,
      rowsPerPagination: 5,
      filteredHealthAndSafety: [],
      order: "",
      orderBy: "desc",
      selectedTabvalue: 0,
      filterKey: "",
      specificBar: undefined,
      groupedBar: [],
      filterBy: ""
    });
  };

  render() {
    const {
      healthAndSafetyDataVertical,
      healthAndSafetyDataHorizontal,
      isOpen,
      header,
      filteredHealthAndSafety,
      rowsPerPagination,
      pageNo,
      rowsPerPageOptions,
      order,
      orderBy,
      configDataHorizontal,
      configDataVertical,
      selectedTabvalue,
      filterKey
    } = this.state;

    return (
      <>
        <div id={this.props.reference + "container"} className={"row"}>
          <div
            id={"hse-categories"}
            className={"col-xs-6 hsc-container hsc-border-right"}
          >
            <div className={"hse-header"}>{"HSE Reported Categories"}</div>
            {healthAndSafetyDataVertical?.length > 0 ? (
              <RenderGroupedVerticalBarChart
                data={healthAndSafetyDataVertical}
                config={configDataVertical}
                GetSummary={this.GetSummary}
                filterData={"CategoryName"}
              />
            ) : (
              <div className={"no-data-hsc"}>{"No Data Available."}</div>
            )}
          </div>
          <div className={"col-xs-6 hsc-container hsc-border-left"}>
            <div id={"hse-sub-categories"} className={"hse-header"}>
              {"Sub Categories Reported\r"}
            </div>
            {healthAndSafetyDataHorizontal?.length > 0 ? (
              <RenderGroupedHorizontalBarChart
                data={healthAndSafetyDataHorizontal}
                config={configDataHorizontal}
                GetSummary={this.GetSummary}
                filterData={"SubCategoryName"}
              />
            ) : (
              <div className={"no-data-hsc"}>{"No Data Available."}</div>
            )}
          </div>
        </div>
        {isOpen && (
          <Dialog
            id={"hse-dialog-categories"}
            maxWidth={"lg"}
            open={isOpen}
            disableBackdropClick
            onClose={() => this.closePopup()}
            PaperComponent={PaperComponent}
            aria-labelledby={"responsive-dialog-title"}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  <DialogTitle
                    style={{ cursor: "move" }}
                    id={"responsive-dialog-title"}
                    className={"common-color white-label"}
                  >
                    {header}
                  </DialogTitle>
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => {
                      this.closePopup();
                    }}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>
            <DialogContent>
              <DialogContentText>
                <AppBar position={"static"} color={"default"}>
                  <Tabs
                    value={selectedTabvalue}
                    onChange={this.handleTabChange}
                    indicatorColor={"primary"}
                    textColor={"primary"}
                    variant={"fullWidth"}
                    aria-label={"full width tabs example"}
                  >
                    <Tab label={"Summary Data"} {...this.tabProps(0)} />
                    <Tab label={"Details"} {...this.tabProps(1)} />
                  </Tabs>
                </AppBar>
                <TabPanel value={selectedTabvalue} index={0}>
                  {
                    <PopupTable
                      data={filteredHealthAndSafety}
                      columns={summaryColumn}
                      rowsPerPagination={rowsPerPagination}
                      pageNo={pageNo}
                      updateRowCount={this.updateRowCount}
                      sortBy={this.sortBy}
                      rowsPerPageOptions={rowsPerPageOptions}
                      order={order}
                      orderBy={orderBy}
                      onCountClick={this.onCountClick}
                    />
                  }
                </TabPanel>
                <TabPanel value={selectedTabvalue} index={1}>
                  {
                    <PopupTable
                      data={filteredHealthAndSafety}
                      columns={
                        filterKey === "CategoryName"
                          ? columns.filter(
                              x =>
                                x.key !== "CategoryName" &&
                                x.key !== "SubCategoryName"
                            )
                          : columns.filter(x => x.key !== "SubCategoryName")
                      }
                      rowsPerPagination={rowsPerPagination}
                      pageNo={pageNo}
                      updateRowCount={this.updateRowCount}
                      sortBy={this.sortBy}
                      rowsPerPageOptions={rowsPerPageOptions}
                      order={order}
                      orderBy={orderBy}
                    />
                  }
                </TabPanel>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
      </>
    );
  }
}

export default HealthAndSeftyGrphBarChart;
